<template>
    <div>
        <!-- Participants and Chats Tab -->
        <div class="Chatroom-screen-chat-options">
            <ul class="Chatroom-screen-chat-ul">
                <li class="tab chat-list-opt-first" :class="(activeTab == 'member_participants' ? 'active' : null)" @click="$emit('switchTabView','member_participants')">
                    {{ $t('screener.chatroom.member.label') }}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
                    </svg>
                </li>
                <li class="tab chat-list-opt-second" :class="(activeTab == 'member_chats' ? 'active' : null)" @click="$emit('switchTabView','member_chats')">
                    {{ $t('screener.chatroom.chats.label') }}
                    <tempalte v-if="chatHistoryMembers.length > 0 && unreadMessageCount > 0">
                        <div class="chat-counter">
                            <p>{{ unreadMessageCount }}</p>
                        </div>
                    </tempalte>
                    <template v-else>
                        <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 chat-icon-list">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                        </svg>
                    </template>
                </li>
            </ul>
            <ul class="Chatroom-screen-list-icons">
                <li>
                    <div class="chatroom-logged-user-dropdown">
                        <button class="profile-button" @click="showEditProfileDropdown = !showEditProfileDropdown">
                            <div class="avatar">
                                <img alt="Profile" class="profile-image" :src="senderProfileImage" />
                            </div>
                            <span class="online-dot"></span>
                        </button>

                        <!-- Dropdown Menu -->
                        <div class="dropdown-menu" :class="(showEditProfileDropdown) ? 'show' : null" id="profileDropdown">
                            <div class="dropdown-header">
                                <h4>{{ senderUser.name }}</h4>
                                <p>Online</p>
                            </div>
                            <button class="dropdown-item" @click="updateSenderProfile">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                </svg>
                                <span>{{ $t('screener.chatroom.user.profile.update_profile_dropdown.label') }}</span>
                            </button>
                            <!-- <button class="dropdown-item">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span>Settings</span>
                            </button>
                            <button class="dropdown-item border-top">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                </svg>
                                <span>Sign Out</span>
                            </button> -->
                        </div> 
                    </div>
                </li>
                <li id="close-button">
                    <button class="close-button" @click="$emit('closeDrawer')">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                            class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </li>
            </ul>
        </div>
        <!-- Participants and Chats Tab -->

        <div class="Chatroom-screen-chat-area">
            <!-- Chat Participants Users -->
            <div id="participants-content" class="tab-content" :style="(activeTab == 'member_participants' ? 'display:block' : 'display:none')">
                <!-- If Online and Offline Users Are Present -->
                <template v-if="roomMembers.length > 0">
                    <div id="chatpanel" :class="(participantsView == 'list') ? 'members-main-wrapper' : 'grid-main-wrapper'">
                        <template v-if="participantsView == 'list'">
                            <!-- Online Users -->
                            <div id="users">
                                <div class="toggle-Chatroom-screen-chat-options">
                                    <div class="online-users-count">
                                        <p class="display-title">{{ $t('screener.chatroom.current.online.label') }} <span>{{ roomMembers.length }}</span> </p>
                                    </div>
                                    <ul class="Chatroom-online-list-icons">
                                        <li class="tab" @click="switchListingView('list')">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                class="size-6" style="color: #ffffff" >
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                                            </svg>
                                        </li>
                                        <li class="tab" @click="switchListingView('grid')">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                class="size-6" style="color: #9B9C9E">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
                                            </svg>
                                        </li>
                                    </ul>
                                </div>
                                <ul>
                                    <template v-for="onlineUser in roomMembers">
                                        <li class="user" :key="onlineUser.id">
                                            <UserListItem 
                                                :sender="onlineUser"
                                                :receiver="senderUser" 
                                                @handleSelection="handleSelection"/>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                            <!-- Online Users -->
                        </template>
                        <template v-else>
                            <div id="users">
                                <div id="grid-content">
                                    <div class="toggle-Chatroom-screen-chat-options">
                                        <div class="online-users-count">
                                            <p class="display-title">{{ $t('screener.chatroom.all.members.label') }}</p>
                                        </div>
                                        <ul class="Chatroom-online-list-icons">
                                            <li class="tab" @click="switchListingView('list')">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                    class="size-6" style="color: #9B9C9E">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                                                </svg>
                                            </li>
                                            <li class="tab" @click="switchListingView('grid')">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                    class="size-6" style="color: #ffffff">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
                                                </svg>
                                            </li>
                                        </ul>
                                    </div>
                                    <ul class="grid-listing-view">
                                        <template v-for="onlineUser in roomMembers">
                                            <li class="user" :key="`grid_${onlineUser.id}`">
                                                <UserListItem 
                                                    v-if="onlineUser.consumer_id!=profile.id"
                                                    viewType="grid"
                                                    :sender="onlineUser"
                                                    :receiver="senderUser" 
                                                    @handleSelection="handleSelection"/>
                                            </li>
                                        </template>
                                        
                                    </ul>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
                <!-- If Online and Offline Users Are Present -->
                
                <!-- Show Blank Screen -->
                <template v-else>
                    <div class="blank-text">
                        <p>{{ $t('screener.chatroom.no.participants.message') }}</p>
                    </div>
                </template>
                <!-- Show Blank Screen -->
            </div>
            <!-- Chat Participants Users -->

            <!-- Chatiing Friends Users -->
            <div id="chats-content" class="tab-content" :style="(activeTab == 'member_chats' ? 'display:block' : 'display:none')">
                <div id="chatpanel" class="chats-main-wrapper">
                    <template v-if="chatHistoryMembers.length > 0 ">
                        <div id="users">
                            <div class="toggle-Chatroom-screen-chat-options">
                                <div class="online-users-count">
                                    <p class="display-title">{{ $t('screener.chatroom.recent.chats.label') }} <span>{{ chatHistoryMembers.length }}</span> </p>
                                </div>
                                <!-- <ul class="Chatroom-online-list-icons">
                                    <li class="tab">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            class="size-6">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                                        </svg>
                                    </li>
                                    <li class="tab">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            class="size-6">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
                                        </svg>
                                    </li>
                                </ul> -->
                            </div>
                            <ul>
                                <template v-for="chats in chatHistoryMembers">
                                    <li class="user" :key="chats.id">
                                        <UserListItem 
                                            :sender="chats"
                                            :receiver="senderUser"
                                            :chatID="[chats.id, senderUser.id].sort().join('_')" 
                                            :chatroomID="chatRoomID"
                                            @handleSelection="handleSelection"/>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </template>
                    <!-- Show Blank Screen -->
                    <template v-else>
                        <div class="blank-text">
                            <p>{{ $t('screener.chatroom.no.chats.message') }}</p>
                            <button class="chat-button" @click="$emit('switchTabView','member_participants')">
                                {{ $t('screener.chatroom.user.chat.history.button.label') }}
                            </button>
                        </div>
                    </template>
                    <!-- Show Blank Screen -->
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import UserListItem from '../Presentational/MemberListCard.vue'
import defaultProfileImage from '@/assets/placeholder.jpg';

export default {
    name: 'MembersListings',
    components: {
        UserListItem,
    },
    props: {
        chatRoomID: {
            type: String,
            require:true
        },
        activeTab: {
            type: String,
            default:null
        },
        roomMembers: {
            type: Array,
            default:null
        },
        chatHistoryMembers: {
            type: Array,
            default:null
        },
        senderUser: {
            type: Object,
            default:null
        },
        unreadMessageCount : {
            type: Number,
            default: 0
        }
    },
    computed: {
        ...mapState({
            profile: (state) => state.consumer.profile,
        }),
        senderProfileImage() {
            if (this.senderUser && 'profile_image' in this.senderUser) {
                return this.senderUser.profile_image || defaultProfileImage;
            }else{
                return defaultProfileImage;
            }
        },
        chatUnreadMessageOnChatTab() {
            let show = true;
            if (this.chatHistoryMembers.length > 0 && this.unreadMessageCount) {
                
            }
        }
    },
    data() {
        return {
            participantsView:'list',
            showEditProfileDropdown:false
        }
    },
    methods: {
        handleSelection(event, type) {
            if (!event.is_rejected) {
                if (type == 'profile') {
                    this.$emit('toggleUserProfile', event)
                }else{
                    this.$emit('handleChatSelection',event)  
                }
            }else{
                alert('Rejected Profile')
            }
        },
        switchListingView(type) {
            this.participantsView = type
        },
        updateSenderProfile(){
            this.showEditProfileDropdown = false
            this.$emit('handleProfileUpdate')
        }

    }      
}
</script>
